module.exports = __webpack_public_path__ + "static/media/ws.ba3b49ec.jpeg";